var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeofenceAddPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_526_1",
    "data-name": "Component 526 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.902,
    height: 36.367,
    viewBox: "0 0 43.902 36.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.151,
    y1: 0.301,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22046b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c979ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11337",
    "data-name": "Path 11337",
    d: "M100.95,39.184H66.291a1.48,1.48,0,0,0-1.507,1.507v5.525H93.918a1.48,1.48,0,0,1,1.507,1.507V68.87h5.525a1.48,1.48,0,0,0,1.507-1.507V40.691A1.48,1.48,0,0,0,100.95,39.184Z",
    transform: "translate(-58.556 -39.184)",
    fill: "#c1b5df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11338",
    "data-name": "Path 11338",
    d: "M35.664,109.192H1.507A1.48,1.48,0,0,0,0,110.7v26.623a1.48,1.48,0,0,0,1.507,1.507H35.664a1.48,1.48,0,0,0,1.507-1.507V110.7A1.48,1.48,0,0,0,35.664,109.192Z",
    transform: "translate(0 -102.461)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11339",
    "data-name": "Path 11339",
    d: "M118.113,168.83a4.219,4.219,0,1,0-4.219-4.219A4.245,4.245,0,0,0,118.113,168.83Z",
    transform: "translate(-102.943 -148.737)",
    fill: "#7f5096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11340",
    "data-name": "Path 11340",
    d: "M81.868,216.4a1.582,1.582,0,0,0-1.155-.7,1.361,1.361,0,0,0-1.256.553l-5.525,6.53-2.411-1.658a1.31,1.31,0,0,0-1.105-.251,1.388,1.388,0,0,0-.954.6l-4.521,6.329a1.567,1.567,0,0,0-.1,1.557,1.469,1.469,0,0,0,1.356.8h21.65a1.448,1.448,0,0,0,1.306-.8,1.472,1.472,0,0,0-.05-1.507Z",
    transform: "translate(-58.46 -198.723)",
    fill: "#be71a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceAddPhoto);
export default __webpack_public_path__ + "static/media/geofenceAddPhoto.eb98cf45ef531de4451b89e80db504e0.svg";
export { ForwardRef as ReactComponent };